import { useState } from 'react';
import { useAsyncEffect } from 'ahooks';
import { queryPageAuthority } from '@gp/services/global';

export default function useDPSReportsPermission() {
  const [isLoading, setIsLoading] = useState(true);
  // 预览、新增、编辑、删除权限 通用操作权限
  const [permissions, setPermissions] = useState<{ view: boolean; edit: boolean }>({ view: false, edit: false });

  const hasViewPermission = !!permissions?.view;

  const hasEditPermission = !!permissions?.edit;

  useAsyncEffect(async () => {
    try {
      setIsLoading(true);
      const { view, edit } = await queryPageAuthority({
        assort: 'dps_weekly_report',
      });
      setPermissions({
        view: !!view,
        edit: !!edit,
      });
    } catch (exception) {
      setPermissions({
        view: false,
        edit: false,
      });
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { isLoading, permissions, hasViewPermission, hasEditPermission };
}
